/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_ExpandInputs */



/**
* | output |
* | --- |
* | "Expand the event text horizontally" |
*
* @param {Shortcut_Keys_Desc_ExpandInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_expand = /** @type {((inputs?: Shortcut_Keys_Desc_ExpandInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_ExpandInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Etendre le texte de l'evenement horizontalement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Den Ereignistext horizontal ausdehnen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Espandi orizzontalmente il testo dell'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Разверните текст события по горизонтали.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Expandir el texto del evento horizontalmente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("水平展开事件文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントテキストを水平に拡大する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट टेक्स्ट को क्षैतिज रूप से विस्तारित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Expanda o texto do evento horizontalmente.")
	return /** @type {LocalizedString} */ ("Expand the event text horizontally")
});